module.exports = __webpack_public_path__ + "117b14b970d88db3b7d2126400d750ed.png";